

// This function takes a month number (0-11) and returns the short name of the month
export function getMonthNameShort(month: number): string {
    const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];

    return monthNames[month];
};
